import axios from "axios";

const baseURL = process.env.REACT_APP_WEBSITE_API_URL || "https://api-dev.codeelan.com";

const axiosInstance = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 30000, // 30 seconds timeout
});

export const apiCall = async (payload) => {
  try {
    const response = await axiosInstance.post("", payload);
    return response;
  } catch (error) {
    console.error("API Call Error:", error);
    throw error; // Re-throw the error so calling components can handle it
  }
};
